import { createFileRoute, notFound } from "@tanstack/react-router";
export const Route = createFileRoute("/design-system/")({
  beforeLoad: () => { throw notFound(); },
});